// extracted by mini-css-extract-plugin
module.exports = {"container":"_3s82V","button":"_31UVE","isSecondary":"_1fjob","icon":"OqjHX"};